import { TextField } from '@material-ui/core'
import { NumericFormat } from 'react-number-format'

const PercentageField = ({
   variant = 'outlined',
   onChange,
   min = 0,
   max = 100,
   ...otherProps
}) => {
   return (
      <NumericFormat
         {...otherProps}
         suffix="%"
         variant={variant}
         allowNegative={false}
         isAllowed={({ floatValue }) => {
            if (!floatValue) return true
            return floatValue <= max && floatValue >= min
         }}
         onValueChange={({ floatValue }) => {
            onChange(parseFloat(floatValue))
         }}
         customInput={TextField}
      />
   )
}

export default PercentageField
